import moment from "moment-timezone";
import {BranchType} from "../enums/enums";

const timezone = 'Asia/Kolkata';
export const getTableColumns = ({ActionDropdown, userRole}) => {
    let tableColumns = [];

    // Add Internal Branch Name only for Main branch
    if (userRole?.branchType === BranchType.Main) {
        tableColumns.push({header: "Internal Branch Name", field: "internalBranchName"});
    }

    // Always include these columns
    tableColumns.push(
        {header: "Employee", field: "employee"},
        {header: "Purchase Date", field: "purchaseDate"},
        {header: "Products", field: "products"}
    );

    // Action column
    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} view={true}/>,
    });

    return tableColumns;
};


export const getTableData = ({items = [], internalBranch, productList, employee}) => {
    if (!Array.isArray(items)) return [];

    return items.map((item) => ({
        id: item.id,
        internalBranchName: internalBranch[item?.internalBranchName],
        employee: item.employee ? employee[item?.employee] : "-",
        purchaseDate: item.purchaseDate ? moment(item.purchaseDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : '-',
        products: (
            <div>
                {item.products?.map((p, index) => (
                    <span key={index}>
                {productList[p.product]} (x{p.quantity})
                        {index < item.products.length - 1 && ", "}
            </span>
                ))}
            </div>
        ),
    }));
};

export const getDetailData = ({item, internalBranch, employee}) => {
    if (!item) return {details: {}};
    return {
        details: {
            internalBranchName: internalBranch[item?.internalBranchName],
            employee: employee[item?.employee],
            paymentDate: item.purchaseDate ? moment(item.purchaseDate).tz(timezone).format('MMM DD, YYYY, hh:mm A') : '-',
            note: item.note,
        }
    };
}

export const getOrderItemTableColumns = () => {
    let tableColumns = [
        {header: "Product", field: "product"},
        {header: "Quantity", field: "quantity"},
    ];
    return tableColumns;
};

export const getOrderItemTableData = ({products = [], productList}) => {
    if (!Array.isArray(products)) return [];
    return products.map((item) => ({
        product: productList[item.product],
        quantity: item.quantity,
    }));
};